import React, { ReactElement, useContext } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { NavLink, useParams } from 'react-router-dom';
import styles from './AppCreateButton.module.less';
import CcxIconDownOutlined from '../ccx/icons/CcxIconDownOutlined';
import CreateVpcButton from '../vpc/CreateVpcButton';
import CcxComponentProps from '../../core/CcxComponent';
import {
    DeploymentsContext,
    DeploymentsContextProps,
} from '../../core/context/DeploymentsContext';
import { UserContext } from '../../core/context/UserContext';
import { vpcDisabled } from '../../core/CcxEnv';
import User from '../../types/User';

interface UrlProps {
    projectUuid?: string;
}

interface Props extends CcxComponentProps {}

function AppCreateButton({ testId = 'AppCreateButton' }: Props): ReactElement {
    let { projectUuid } = useParams<UrlProps>();

    const deploymentContext = useContext(DeploymentsContext);
    const { user: userContext } = useContext(UserContext);

    const menu = () => {
        const limitReached = userReachedDatastoreLimit(
            deploymentContext,
            userContext
        );
        return (
            <Menu>
                <Menu.Item
                    data-testid={`${testId}AddDataStoreMenuOption`}
                    key={`/projects/${
                        projectUuid || 'default'
                    }/data-stores/add`}
                    disabled={limitReached}
                    title={limitReached ? userContext?.disabledText : ''}
                >
                    <NavLink
                        data-testid={`${testId}AddDataStoreLink`}
                        to={`/projects/${
                            projectUuid || 'default'
                        }/data-stores/add`}
                    >
                        Datastore
                    </NavLink>
                </Menu.Item>

                <Menu.Item
                    data-testid={`${testId}AddVpcMenuOption`}
                    key={`/projects/${projectUuid || 'default'}/vpcs/add`}
                    title={limitReached ? userContext?.disabledText : ''}
                >
                    {!vpcDisabled && (
                        <CreateVpcButton
                            buttonType="text"
                            buttonText="VPC"
                            className={styles.AppCreateButtonCreateVpcLink}
                            testId={`${testId}AddVpcButton`}
                        />
                    )}
                </Menu.Item>
            </Menu>
        );
    };

    return (
        <Dropdown overlay={menu} trigger={['click']}>
            <Button
                data-testid={`${testId}Button`}
                className={styles.AppCreateButtonButton}
            >
                Create <CcxIconDownOutlined />
            </Button>
        </Dropdown>
    );
}

export function userReachedDatastoreLimit(
    deploymentContext: DeploymentsContextProps,
    user?: User
) {
    return (
        user?.verifiedLevel === 0 &&
        (user?.maxDataStores || 0) > 0 &&
        (deploymentContext.deployments?.notDeletingLength() || 0) >=
            (user?.maxDataStores || 0)
    );
}

export default AppCreateButton;
